import { NodeViewWrapper } from "@tiptap/react";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { useShowCopilot } from "../hooks/useShowCopilot";
import { CleanupWrapper } from "./CleanupWrapper";
import { DraftPrompt } from "./DraftPrompt";
import { CompassDraftPrompt } from "./DraftPrompt/CompassDraftPrompt";
import { EditionPrompt } from "./EditionPrompt";
import { CompassEditPrompt } from "./EditionPrompt/CompassEditPrompt";
import { AiBlockContextProvider } from "./hooks/useAiBlockContext";

export const AiCopilotBlock = ({ editor, node, getPos, deleteNode }) => {
  const { range } = node.attrs;

  const { shouldShowCopilot } = useShowCopilot();
  const { isCircleV4 } = useCircleV4();

  if (!shouldShowCopilot) {
    return null;
  }

  const legacyPrompt = (
    <div className="from-ai-start to-ai-end relative z-10 w-full rounded-md bg-gradient-to-r p-0.5 shadow-xl">
      {range ? <EditionPrompt /> : <DraftPrompt />}
    </div>
  );

  const compassPrompt = (
    <div className="relative z-10 w-full">
      {range ? <CompassEditPrompt /> : <CompassDraftPrompt />}
    </div>
  );

  return (
    <AiBlockContextProvider
      editor={editor}
      node={node}
      getPos={getPos}
      deleteNode={deleteNode}
    >
      <NodeViewWrapper>
        <CleanupWrapper>
          <div className="mx-auto my-4 flex items-center justify-center">
            {isCircleV4 ? compassPrompt : legacyPrompt}
          </div>
        </CleanupWrapper>
      </NodeViewWrapper>
    </AiBlockContextProvider>
  );
};
